import { render, staticRenderFns } from "./messageDashParent.vue?vue&type=template&id=5dcd2150&"
import script from "./messageDashParent.vue?vue&type=script&lang=js&"
export * from "./messageDashParent.vue?vue&type=script&lang=js&"
import style0 from "./messageDashParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports